import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetTramEstado } from '../../shared/interfaces/database/configuracion';


@Injectable({
  providedIn: 'root'
})
export class TramEstadoService {
  private readonly baseUrl = `${environment.apiUrl}/api/tram-estado`;

  constructor(private http: HttpClient) { }

  getTramEstados(): Observable<IGetTramEstado[]> {
    return this.http.get<IGetTramEstado[]>(`${this.baseUrl}`);
  }
}
